import { gql } from '@apollo/client'

export const GET_COUNTRY_CHARTS = gql`
  query ($countryCode: String!) {
    getCountryCharts(countryCode: $countryCode) {
      artist
      chart
      configuration
      country_code
      date
      origin
      rank
      title
      campaign_id
      product_id
      label_id
    }
  }
`
